module.exports = __webpack_public_path__ + "application/templates/default/inner/module-movements/module-movements.template.html";